import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 72px);

    .first-row-container {
        display: flex;
        flex-direction: row;
        margin: 32px 0;
    }

    .permissionAlert {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .customLi {
        list-style-type: disc;
    }

    &.container {
        margin-right: auto;
        margin-left: auto;
        padding-left: 15px;
        padding-right: 15px;
    }
    &.container:after,
    &.container:before {
        content: ' ';
        display: table;
    }
    &.container:after {
        clear: both;
    }
    @media (min-width: 992px) {
        &.container {
            width: 750px;
            width: 970px;
        }
    }
    @media (min-width: 1600px) {
        &.container {
            width: 1170px;
        }
    }
    &.container-fluid {
        margin-right: auto;
        margin-left: auto;
        padding-left: 15px;
        padding-right: 15px;
    }
    &.container-fluid:after,
    &.container-fluid:before {
        content: ' ';
        display: table;
    }
    &.container-fluid:after {
        clear: both;
    }
`
